import { Injectable } from '@angular/core';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/core/service/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TrainingDetailsService {
  refreshFeedback = new BehaviorSubject<boolean>(false);
  refreshTrainingDetails = new BehaviorSubject<number>(0);
  constructor(private apiService: ApiService) {
  }

  getTrainingDetails(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/training_details`, model)
      .pipe(catchError(this.handleError));
  }

  getTrainingTopicList(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_all_topics`, model)
      .pipe(catchError(this.handleError));
  }

  editTopicList(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/edit_topics`, model)
      .pipe(catchError(this.handleError));
  }

  getTrainingMaterialList(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_all_materials`, model)
      .pipe(catchError(this.handleError));
  }

  addTrainingMaterial(model) {
    const formData = new FormData();
    formData.append('tc_token', model.tc_token);
    formData.append('material_type', model.material_type);
    model.materials.forEach((element) => {
      if (element.type) {
        formData.append('materials[]', element, element.name);
      } else {
        formData.append('materials[]', element.externalLink);
      }
    });

    return this.apiService
      .post(`${environment.apiUrl}/api/system/add_new_materials`, formData)
      .pipe(catchError(this.handleError));
  }

  removeTrainingMaterial(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/remove_materials`, model)
      .pipe(catchError(this.handleError));
  }


  getTrainingFilesList(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_all_files`, model)
      .pipe(catchError(this.handleError));
  }

  addTrainingFiles(model) {
    const formData = new FormData();
    formData.append('tc_token', model.tc_token);
    model.files.forEach((element) => {
      if (element.type) {
        formData.append('files[]', element, element.name);
      }
    });

    return this.apiService
      .post(`${environment.apiUrl}/api/system/add_new_files`, formData)
      .pipe(catchError(this.handleError));
  }
  removeFiles(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/remove_files`, model)
      .pipe(catchError(this.handleError));
  }


  getFAQList(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_all_faq`, model)
      .pipe(catchError(this.handleError));
  }

  addFAQ(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/add_new_faq`, model)
      .pipe(catchError(this.handleError));
  }

  editFAQ(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/edit_faq`, model)
      .pipe(catchError(this.handleError));
  }

  uploadPhotos(model) {
    const formData = new FormData();
    formData.append('tc_token', model.tc_token);
    model.photos.forEach((element) => {
      formData.append('photos[]', element, element.name);
    });

    return this.apiService
      .post(`${environment.apiUrl}/api/system/add_new_photos`, formData)
      .pipe(catchError(this.handleError));
  }

  searchForMembersToInvite(model) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/search_members_for_training`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  addMemberToTraining(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/add_training_members`, model)
      .pipe(catchError(this.handleError));
  }

  getAttendeesList(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_all_attendees`, model)
      .pipe(catchError(this.handleError));
  }

  getAttendeesListToSendEmails(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/get_attendees_to_send_email`, model)
      .pipe(catchError(this.handleError));
  }

  getInvitedList(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_all_invited`, model)
      .pipe(catchError(this.handleError));
  }

  onApproveAttendees(model) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/tm_approve_course_enrollment`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  assignTrainingPaymentResponsible(model) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/assign_training_payment_responsible`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  onDecline(model, endPoint) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/${endPoint}`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  getTrainingDeclineReason() {
    return this.apiService
      .get(`${environment.apiUrl}/api/system/get_training_decline_reason`)
      .pipe(catchError(this.handleError));
  }

  onRemoveAttendees(model) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/tm_remove_course_enrollment`,
        model
      )
      .pipe(catchError(this.handleError));
  }


  getInstructorList(model) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/search_members_for_instructor`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  assignInstructorToCourse(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/assign_instructor`, model)
      .pipe(catchError(this.handleError));
  }

  removeInstructor(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/remove_instructor`, model)
      .pipe(catchError(this.handleError));
  }

  assignCoordinatorToCourse(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/assign_coordinator`, model)
      .pipe(catchError(this.handleError));
  }

  removeCoordinator(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/remove_coordinator`, model)
      .pipe(catchError(this.handleError));
  }

  deleteTraining(data) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/delete_course`, data)
      .pipe(catchError(this.handleError));
  }

  trainneCancelRequest(model) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/trainee_remove_course_enrollment`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  getPhotosList(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_all_photos`, model)
      .pipe(catchError(this.handleError));
  }

  getAttendanceList(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/attendance_form_list`, model)
      .pipe(catchError(this.handleError));
  }
  addAttendanceForm(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/add_attendance_form`, model)
      .pipe(catchError(this.handleError));
  }

  removePhoto(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/remove_photos`, model)
      .pipe(catchError(this.handleError));
  }

  getCertificateList(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_all_certificates`, model)
      .pipe(catchError(this.handleError));
  }

  issueCertificate(model) {
    if (model.view == 1) {
      return this.apiService
        .getDownload(`${environment.apiUrl}/api/system/issue_certificate`, model)
        .pipe(catchError(this.handleError));
    } else {
      return this.apiService
        .post(`${environment.apiUrl}/api/system/issue_certificate`, model)
        .pipe(catchError(this.handleError));
    }

  }

  issueCertificateForInstractor(model) {
    if (model.view == 1) {
      return this.apiService
        .getDownload(`${environment.apiUrl}/api/system/issue_certificate_for_instructor`, model)
        .pipe(catchError(this.handleError));
    } else {
      return this.apiService
        .post(`${environment.apiUrl}/api/system/issue_certificate_for_instructor`, model)
        .pipe(catchError(this.handleError));
    }

  }

  issueAllCertificate(model) {
    return this.apiService
      .getDownload(
        `${environment.apiUrl}/api/system/issue_all_certificate`,
        model
      )
      .pipe(catchError(this.handleError));
  }
  issueSelectedCertificate(model) {
    return this.apiService
      .getDownload(
        `${environment.apiUrl}/api/system/issue_all_certificate_with_select`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  printAllCertificate(model) {
    return this.apiService
      .getDownload(
        `${environment.apiUrl}/api/system/print_all_certificate`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  myCertificate(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/get_my_certificate`, model)
      .pipe(catchError(this.handleError));
  }

  downloadCertificate(model) {
    return this.apiService
      .getDownload(
        `${environment.apiUrl}/api/system/download_my_certificate`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  getAllQuestions(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/survey_questions`, model)
      .pipe(catchError(this.handleError));
  }

  getSurveyDetails(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/survey_details`, model)
      .pipe(catchError(this.handleError));
  }

  getAllUserSurvey(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/get_all_users_survey`, model)
      .pipe(catchError(this.handleError));
  }

  editSurvey(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/edit_survey_questions`, model)
      .pipe(catchError(this.handleError));
  }

  getAllSurveyAnswers() {
    return this.apiService
      .get(`${environment.apiUrl}/api/system/training_survey_answear`)
      .pipe(catchError(this.handleError));
  }

  getSurveyResult(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/survey_finale_results`, model)
      .pipe(catchError(this.handleError));
  }

  traineeSubmitSurveyAnswers(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/trainee_add_feed`, model)
      .pipe(catchError(this.handleError));
  }

  getAllCertificatesTrainee(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_certificates`, model)
      .pipe(catchError(this.handleError));
  }

  getCertificatesForInstractor(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_certificates_for_instructor`, model)
      .pipe(catchError(this.handleError));
  }

  downloadAllCertificatesTrainee(model) {
    return this.apiService
      .getDownload(`${environment.apiUrl}/api/system/download_all_certificate`, model)
      .pipe(catchError(this.handleError));
  }

  downloadAllCertificatePDF(model) {
    return this.apiService
      .getDownload(`${environment.apiUrl}/api/system/download_all_certificate_pdf `, model)
      .pipe(catchError(this.handleError));
  }
  deleteAllCertificateWithSelect(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/delete_all_certificate_with_select`, model)
      .pipe(catchError(this.handleError));
  }

  getAllTemplateCertificates(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/template_certificates`, model)
      .pipe(catchError(this.handleError));
  }
  sendEmailForAttendeesTraining(model) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/send_email_for_attendees_training`,
        model
      )
      .pipe(catchError(this.handleError));
  }
  downloadSurvey(model) {

    return this.apiService
      .getDownload(
        `${environment.apiUrl}/api/system/export_user_survy_pdf`,
        model
      )
      .pipe(catchError(this.handleError));
  }
  allPaymentRequestsForCourse(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_all_training_payment_for_course`, model)
      .pipe(catchError(this.handleError));
  }
  allRefundedPaymentsForCourse(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_course_refund_requests`, model)
      .pipe(catchError(this.handleError));
  }

  ApproveRefundRequest(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/tm_approve_refund`, model)
      .pipe(catchError(this.handleError));
  }

  DeclineRefundRequest(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/tm_decline_refund`, model)
      .pipe(catchError(this.handleError));
  }

  addNotes(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/tm_add_enrollment_notes`, model)
      .pipe(catchError(this.handleError));
  }
  deleteTrainingCertificate(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/delete_training_certificate`, model)
      .pipe(catchError(this.handleError));
  }
  downloadAttendanceAsPdf(model) {
    return this.apiService
      .getDownload(
        `${environment.apiUrl}/api/system/download_attendance_pdf`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  getDownloadBadge(model) {
    return this.apiService
      .getDownload(
        `${environment.apiUrl}/api/system/download_badge_pdf`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  AddNotes(model) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/tm_add_attendance_notes`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  GetStatistics(model) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/course_statistics`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  DownloadStatistics(model) {
    return this.apiService
      .getDownload(
        `${environment.apiUrl}/api/system/course_statistics_pdf`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  PaymentNotes(model) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/tm_add_payment_notes`,
        model
      )
      .pipe(catchError(this.handleError));
  }


  RemovePayment(model) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/tm_remove_course_payment `,
        model
      )
      .pipe(catchError(this.handleError));
  }

  SendCertificateToInstructor(model) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/tm_send_certificate_to_instructor`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  SendMailToInstructor(model) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/send_email_for_instructor`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  importAttendees(model) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/import_invited_members`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  courseSurveyExport(model) {
    return this.apiService
      .getDownload(
        `${environment.apiUrl}/api/system/courseSurveyExport`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  refundRequest(model) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/trainee_request_refund`,
        model
      )
      .pipe(catchError(this.handleError));
  }
  
  handleError(error) {
    return throwError(error);
  }
}
